import React, { useEffect, useState } from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonButton,
  IonImg,
  IonLabel,
  IonInput,
  isPlatform,
} from "@ionic/react";
import "./offers.scss";
import * as constants from "../../../constants";
import { connect } from "react-redux";
import { saveUserRefferal } from "../../../Store/Actions";
import { ToastMessage } from "../../../utils/toastMessage";
import { SocialSharing } from "@ionic-native/social-sharing";
import { checkMediaQuery } from "../../../utils";
import "../../../global.scss";

const ReferAndEarn: React.FC = (props: any) => {
  const data = props.referalDetails;
  const [refCode, setRefCode] = useState("");
  const [toast, setToast] = useState({
    showToast: false,
    toastMessage: "",
    severity: "",
  });
  const [keyboardOpened, setKeyboardOpened] = useState(false);

  const handleRedeem = async (code: any) => {
    try {
      if (!code) {
        throw new Error("Please enter valid referral code");
      }
      const refSuc = await props.saveUserRefferal(code);
      if (!!refSuc && !!refSuc.error && !!refSuc.error.title) {
        throw new Error(refSuc.error.title);
      }
      if (!!refSuc && refSuc.status === "SUCCESS") {
        setRefCode("");
        throw new Error(refSuc.data[0].message);
      }
    } catch (error: any) {
      setToast({
        showToast: true,
        toastMessage: error.message,
        severity: "warning",
      });
    }
  };

  const onHandleShare = () => {
    if (isPlatform("desktop")) {
      window.navigator.clipboard.writeText(
        `Use my referral code ${props.referalDetails[0].code} ${constants.DYNAMIC_LINK}`,
      );
      setToast({
        showToast: true,
        toastMessage: "Referral code copied to clipboard",
        severity: "warning",
      });
    } else {
      SocialSharing.share(
        `Use my referral code ${props.referalDetails[0].code} ${constants.DYNAMIC_LINK}`,
      )
        .then(() => {
          console.error("Accepted");
        })
        .catch(() => {
          console.error("Failed");
        });
    }
  };

  useEffect(() => {
    window.addEventListener("keyboardWillShow", () => {
      if (isPlatform("ios")) {
        setKeyboardOpened(true);
      }
    });
    window.addEventListener("keyboardDidHide", () => {
      setKeyboardOpened(false);
    });
    return () => {
      window.removeEventListener("keyboardWillShow", () => {
        setKeyboardOpened(false);
      });
      window.removeEventListener("keyboardDidHide", () => {
        setKeyboardOpened(false);
      });
    };
  }, []);

  return (
    <IonCol className="middle_panle res_bg_color" size-md="6">
      {isPlatform("ios") && <div className="ios_statusbar_color" />}
      <div className="personal_details_text offers_header">
        <div
          className="personal_details_div_child offer_header_child wholeApp heightAuto"
          style={{ paddingTop: isPlatform("android") ? 20 : 0 }}
        >
          <IonImg
            src={checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"}
            // src="/images/back_arrow.svg"
            className="back_arrow"
            onClick={() => props.history.goBack()}
          />
          <IonLabel className="personal_details_labels" color="secondary">
            {constants.REFER_AND_EARN}
          </IonLabel>
          <div />
        </div>
      </div>
      <div
        className="referal_layout"
        style={
          keyboardOpened
            ? {
                marginTop: isPlatform("ios") ? 80 : 50,
                height: "auto",
                marginBottom: 0,
              }
            : {
                marginTop: isPlatform("ios") ? 80 : 50,
              }
        }
        // style={{
        //   marginTop: isPlatform("ios") ? 80 : 50,
        //   height: "auto",
        //   marginBottom: 0,
        // }}
      >
        {/* <div className="newly_added web">
          <IonLabel>{constants.REFER_AND_EARN}</IonLabel>
        </div> */}
        <div className="newly_added points">
          <IonLabel color="tertiary">{constants.YOUR_EARNINGS}</IonLabel>
          <IonLabel color="primary">
            {!!data.length ? data[0].pointsEarned : 0}
            {constants.FIVE_HUNDRED_POINTS}
          </IonLabel>
        </div>
        <div className="offer_layout refer_and_earn">
          <IonRow className="discount_row">
            <IonCol className="vocher_code" size-md="6" size="7">
              <div className="discount_div res_refer">
                <IonLabel className="discount_percentage" color="secondary">
                  {`Refer & Earn ${
                    !!props.referalDetails.length ? props.referalDetails[0].referralPoint : 0
                  } Points`}
                </IonLabel>
              </div>
              <div className="refer-and-earn your_code">
                <IonLabel className="code_refer">
                  Your code {!!data.length && data[0].code}
                </IonLabel>
                <IonImg
                  src="/images/share_icon.svg"
                  className="share_icon"
                  onClick={() => onHandleShare()}
                />
              </div>
              <IonLabel className="discount_date offer_date">
                {/* {constants.VALID} */}
                {!!data.length && (
                  <span className="date referal_left">
                    {data[0].referralsRemaining} of{" "}
                    {data[0].referralsRemaining + data[0].referralsUsed} referrals left
                  </span>
                )}
              </IonLabel>
            </IonCol>
            <IonCol className="image_panel" size-md="6" size="5">
              <div className="img_scroll">
                <IonImg src="/images/offer_icon.svg" className="refer_earn_slide" />
              </div>
            </IonCol>
          </IonRow>
        </div>
        <div className="terms_and_conditions">
          <IonLabel className="term_conditions_text">{constants.TERMS_AND_CONDITIONS}</IonLabel>
          <IonLabel className="terms">
            {`1. Invite your friends and get ${
              !!props.referalDetails.length ? props.referalDetails[0].referralPoint : 0
            } points`}
          </IonLabel>
          <IonLabel className="terms">{constants.REFER_TERMS_CONDTIONS_TWO}</IonLabel>
          <IonLabel className="terms"> {constants.REFER_TERMS_CONDTIONS_THREE} </IonLabel>
          <IonLabel className="terms"> {constants.REFER_TERMS_CONDTIONS_FOUR} </IonLabel>
          <IonLabel className="terms">
            {" "}
            {`5. Maximum coins of ${
              !!props.referalDetails.length ? props.referalDetails[0].referralPoint * 3 : 0
            } can be earned by a user`}
          </IonLabel>
        </div>
        <div className="newly_added share_code apply_referral_code">
          <IonLabel className="share-code-text">{constants.APPLY_REFERRAL_CODE}</IonLabel>
          <div className="redeem_btn">
            <IonInput
              value={refCode}
              onIonChange={(e: any) => setRefCode((e.target as any).value)}
              className="apply_code"
              type="text"
              placeholder={constants.HAVE_YOU_REFFERAL_CODE}
            />
            <IonButton className="reedem_button" onClick={() => handleRedeem(refCode)}>
              <IonLabel color="customwhite">{constants.REDEEM}</IonLabel>
            </IonButton>
          </div>
        </div>
        <div className="newly_added share_code">
          <IonLabel className="share-code-text">{constants.SHARE_YOUR_REFFERRAL_CODE}</IonLabel>
        </div>
        <div className="newly_added referal_code">
          <IonLabel color="primary">{data.length && data[0].code}</IonLabel>
          <IonImg src="/images/referal_code.svg" onClick={() => onHandleShare()} />
        </div>
        {!!keyboardOpened && (
          <div className="res_screen" style={{ position: "unset" }}>
            <IonLabel className="share-code-text">{constants.APPLY_REFERRAL_CODE}</IonLabel>
            <div className="res_bottom">
              <IonInput
                className="res_referal_code_text"
                onIonChange={(e: any) => setRefCode((e.target as any).value)}
                type="text"
                value={refCode}
                placeholder={constants.HAVE_YOU_REFFERAL_CODE}
              />
              <IonButton
                className="res_btn"
                onClick={() => handleRedeem(refCode)}
                style={{ width: "100%", minWidth: "auto" }}
              >
                <IonLabel color="customwhite">{constants.REDEEM}</IonLabel>
              </IonButton>
            </div>
          </div>
        )}
      </div>
      {!keyboardOpened && (
        <div className="res_screen">
          <IonLabel className="share-code-text">{constants.APPLY_REFERRAL_CODE}</IonLabel>
          <div className="res_bottom">
            <IonInput
              className="res_referal_code_text"
              onIonChange={(e: any) => setRefCode((e.target as any).value)}
              type="text"
              value={refCode}
              placeholder={constants.HAVE_YOU_REFFERAL_CODE}
            />
            <IonButton
              className="res_btn"
              onClick={() => handleRedeem(refCode)}
              style={{ width: "100%", minWidth: "auto" }}
            >
              <IonLabel color="customwhite">{constants.REDEEM}</IonLabel>
            </IonButton>
          </div>
        </div>
      )}
      <ToastMessage
        showToast={toast.showToast}
        ToastMessage={toast.toastMessage}
        severity={toast.severity}
        onDidDismiss={() => {
          setToast({
            showToast: false,
            toastMessage: "",
            severity: "",
          });
        }}
      />
    </IonCol>
  );
};

export default connect(
  ({ userInfo: { referalDetails } }: any) => ({
    referalDetails,
  }),
  {
    saveUserRefferal,
  },
)(ReferAndEarn);
